import { c as _c } from "react/compiler-runtime";
import { useBuyerStore, useBuyerStoreData } from "@/providers/global";
import { useEffect } from "react";

/**
 * Custom hook for initializing favorites from localStorage
 * This hook should be used once in the app root or main layout
 */
export function useFavoritesInitialization() {
  const buyerStore = useBuyerStore();
  useEffect(() => {
    // Initialize favorites from localStorage on mount
    // Only run once on component mount
    if (typeof window !== "undefined") {
      try {
        const storedFavorites = localStorage.getItem("tray_properties");
        if (storedFavorites) {
          const favorites = JSON.parse(storedFavorites);
          // Access store function directly to avoid dependency
          buyerStore.getState().initFavorites(favorites);
        }
      } catch (_error) {
        // console.error("Error loading favorites from localStorage:", _error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array - only run once on mount
}

/**
 * Custom hook for managing favorites
 * This hook provides access to favorites state and actions from the global buyer store
 */
export function useFavorites() {
  const $ = _c(5);
  const favorites = useBuyerStoreData(_temp);
  const setFavorites = useBuyerStoreData(_temp2);
  const toggleFavorite = useBuyerStoreData(_temp3);
  const clearFavorites = useBuyerStoreData(_temp4);
  let t0;
  if ($[0] !== clearFavorites || $[1] !== favorites || $[2] !== setFavorites || $[3] !== toggleFavorite) {
    t0 = {
      favorites,
      setFavorites,
      toggleFavorite,
      clearFavorites
    };
    $[0] = clearFavorites;
    $[1] = favorites;
    $[2] = setFavorites;
    $[3] = toggleFavorite;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}

/**
 * Custom hook for checking if a specific item is favorited
 * This hook only re-renders when the favorite status of the specific item changes
 */
function _temp4(state_2) {
  return state_2.clearFavorites;
}
function _temp3(state_1) {
  return state_1.toggleFavorite;
}
function _temp2(state_0) {
  return state_0.setFavorites;
}
function _temp(state) {
  return state.favorites;
}
export function useIsFavorite(itemId) {
  const $ = _c(5);
  const favorites = useBuyerStoreData(_temp5);
  let t0;
  if ($[0] !== favorites || $[1] !== itemId) {
    let t1;
    if ($[3] !== itemId) {
      t1 = fav => fav._id === itemId;
      $[3] = itemId;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = favorites.some(t1);
    $[0] = favorites;
    $[1] = itemId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}

/**
 * Custom hook for toggling a specific item's favorite status
 * This hook provides an optimized toggle function for a specific item
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _temp5(state) {
  return state.favorites;
}
export function useToggleFavorite(item) {
  const $ = _c(3);
  const toggleFavorite = useBuyerStoreData(_temp6);
  let t0;
  if ($[0] !== item || $[1] !== toggleFavorite) {
    t0 = () => toggleFavorite(item);
    $[0] = item;
    $[1] = toggleFavorite;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function _temp6(state) {
  return state.toggleFavorite;
}